// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/tabs/templates/tabs.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("365c8f"),
    marko_node0 = marko_createElement("div", {
        "class": "tabs-container"
      }, "0", null, 3, 0, {
        i: marko_const_nextId()
      })
      .e("ul", {
          id: "tabs",
          "class": "tabs"
        }, null, null, 0)
      .e("div", {
          "class": "spacer"
        }, null, null, 0)
      .e("div", {
          id: "tab-menu"
        }, null, null, 3)
        .e("span", {
            "class": "fas fa-ellipsis-v"
          }, null, null, 0)
        .e("div", {
            "class": "dropdown-content",
            id: "tab-menu-content"
          }, null, null, 3)
          .e("a", {
              href: "#",
              id: "save-layout"
            }, null, null, 1)
            .t("Save Layout")
          .e("a", {
              href: "#",
              id: "load-layout"
            }, null, null, 1)
            .t("Load Layout")
          .e("a", {
              href: "#",
              id: "default-layout"
            }, null, null, 1)
            .t("Default Layout")
        .e("div", {
            "class": "background-overlay"
          }, null, null, 0);

function render(input, out, __component, component, state) {
  var data = input;

  out.n(marko_node0, component);
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
